module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.clazz,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, _vm._l((_vm.icon.paths), function(path) {
    return _c('path', {
      attrs: {
        "d": path.d,
        "fill": path.fill,
        "stroke": path.stroke
      }
    })
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31d61cfa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-svg-icon/Icon.vue
// module id = 322
// module chunks = 0